import { ofType } from 'redux-observable';
import { switchMap, map, catchError } from 'rxjs/operators';
import { from, of } from 'rxjs';
import { FETCH_STAFF_ROLE_NAMES_REQUEST, EPIC_ERROR } from 'Constants/redux';
import service from 'Api/service';
import { receiveStaffRoleNames } from 'Actions';

const FetchStaffRoleNamesEpic = (action$) =>
  action$.pipe(
    ofType(FETCH_STAFF_ROLE_NAMES_REQUEST),
    switchMap(({ per, page, query, staffRoleType }) =>
      from(
        service.get(
          `${import.meta.env.VITE_API_DOMAIN}/api/staff_roles/names`,
          { per, page, query, type: staffRoleType }
        )
      ).pipe(
        map((response) => receiveStaffRoleNames(response)),
        catchError((error) => {
          console.error('FetchStaffRoleNamesEpic error', error);
          return of({ type: EPIC_ERROR });
        })
      )
    )
  );

export default FetchStaffRoleNamesEpic;
